import { Activity } from "PFTypes";

import css from "./content.module.scss";
import { PostContentBody } from "./post_content_body";

export type PostContentProps = {
  task: Activity;
};

export const PostContent = ({ task }: PostContentProps) => {
  const metadata = task.metadata || {};
  const linkUrl = metadata?.og?.url;
  // We do render an "a" when a link is present and a "div" when is not
  const RenderTag = linkUrl ? "a" : "div";
  const linkProps = linkUrl ? { target: "_blank", rel: "noopener noreferrer", href: linkUrl } : {};

  return (
    <RenderTag className={css.wrapper} {...linkProps}>
      <div>
        <PostContentBody task={task} og={metadata.og} />
      </div>
    </RenderTag>
  );
};
